// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/connector/v1/connector.proto (package mono.connector.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Duration, Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.connector.v1.CreateConnectorRequest
 */ export class CreateConnectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateConnectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateConnectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateConnectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateConnectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: google.protobuf.Struct config = 4;
   */ _define_property(this, "config", void 0), /**
   * @generated from field: map<string, string> credentials = 5;
   */ _define_property(this, "credentials", {}), /**
   * @generated from field: mono.connector.v1.ConnectorMetadata metadata = 6;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: int32 sync_interval_hours = 7;
   */ _define_property(this, "syncIntervalHours", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateConnectorRequest, "runtime", proto3);
_define_property(CreateConnectorRequest, "typeName", "mono.connector.v1.CreateConnectorRequest");
_define_property(CreateConnectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "config",
            kind: "message",
            T: Struct
        },
        {
            no: 5,
            name: "credentials",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 6,
            name: "metadata",
            kind: "message",
            T: ConnectorMetadata
        },
        {
            no: 7,
            name: "sync_interval_hours",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.CreateConnectorResponse
 */ export class CreateConnectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateConnectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateConnectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateConnectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateConnectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.connector.v1.Connector connector = 1;
   */ _define_property(this, "connector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateConnectorResponse, "runtime", proto3);
_define_property(CreateConnectorResponse, "typeName", "mono.connector.v1.CreateConnectorResponse");
_define_property(CreateConnectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "connector",
            kind: "message",
            T: Connector
        }
    ]));
/**
 * @generated from message mono.connector.v1.ListConnectorsRequest
 */ export class ListConnectorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListConnectorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListConnectorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListConnectorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListConnectorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListConnectorsRequest, "runtime", proto3);
_define_property(ListConnectorsRequest, "typeName", "mono.connector.v1.ListConnectorsRequest");
_define_property(ListConnectorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.ListConnectorsResponse
 */ export class ListConnectorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListConnectorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListConnectorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListConnectorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListConnectorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.connector.v1.Connector connectors = 1;
   */ _define_property(this, "connectors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListConnectorsResponse, "runtime", proto3);
_define_property(ListConnectorsResponse, "typeName", "mono.connector.v1.ListConnectorsResponse");
_define_property(ListConnectorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "connectors",
            kind: "message",
            T: Connector,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.connector.v1.GetConnectorRequest
 */ export class GetConnectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetConnectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetConnectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetConnectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetConnectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetConnectorRequest, "runtime", proto3);
_define_property(GetConnectorRequest, "typeName", "mono.connector.v1.GetConnectorRequest");
_define_property(GetConnectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.GetConnectorResponse
 */ export class GetConnectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetConnectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetConnectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetConnectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetConnectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.connector.v1.Connector connector = 1;
   */ _define_property(this, "connector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetConnectorResponse, "runtime", proto3);
_define_property(GetConnectorResponse, "typeName", "mono.connector.v1.GetConnectorResponse");
_define_property(GetConnectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "connector",
            kind: "message",
            T: Connector
        }
    ]));
/**
 * @generated from message mono.connector.v1.UpdateConnectorRequest
 */ export class UpdateConnectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateConnectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateConnectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateConnectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateConnectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string type = 4;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Struct config = 6;
   */ _define_property(this, "config", void 0), /**
   * @generated from field: map<string, string> credentials = 7;
   */ _define_property(this, "credentials", {}), /**
   * @generated from field: mono.connector.v1.ConnectorMetadata metadata = 8;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: int32 sync_interval_hours = 9;
   */ _define_property(this, "syncIntervalHours", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateConnectorRequest, "runtime", proto3);
_define_property(UpdateConnectorRequest, "typeName", "mono.connector.v1.UpdateConnectorRequest");
_define_property(UpdateConnectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "config",
            kind: "message",
            T: Struct
        },
        {
            no: 7,
            name: "credentials",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 8,
            name: "metadata",
            kind: "message",
            T: ConnectorMetadata
        },
        {
            no: 9,
            name: "sync_interval_hours",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.UpdateConnectorResponse
 */ export class UpdateConnectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateConnectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateConnectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateConnectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateConnectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.connector.v1.Connector connector = 1;
   */ _define_property(this, "connector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateConnectorResponse, "runtime", proto3);
_define_property(UpdateConnectorResponse, "typeName", "mono.connector.v1.UpdateConnectorResponse");
_define_property(UpdateConnectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "connector",
            kind: "message",
            T: Connector
        }
    ]));
/**
 * @generated from message mono.connector.v1.DeleteConnectorRequest
 */ export class DeleteConnectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteConnectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteConnectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteConnectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteConnectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteConnectorRequest, "runtime", proto3);
_define_property(DeleteConnectorRequest, "typeName", "mono.connector.v1.DeleteConnectorRequest");
_define_property(DeleteConnectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.DeleteConnectorResponse
 */ export class DeleteConnectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteConnectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteConnectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteConnectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteConnectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteConnectorResponse, "runtime", proto3);
_define_property(DeleteConnectorResponse, "typeName", "mono.connector.v1.DeleteConnectorResponse");
_define_property(DeleteConnectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.SyncConnectorRequest
 */ export class SyncConnectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncConnectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncConnectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncConnectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncConnectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: map<string, string> options = 4;
   */ _define_property(this, "options", {}), /**
   * @generated from field: repeated mono.connector.v1.SyncFilter filters = 5;
   */ _define_property(this, "filters", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncConnectorRequest, "runtime", proto3);
_define_property(SyncConnectorRequest, "typeName", "mono.connector.v1.SyncConnectorRequest");
_define_property(SyncConnectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "options",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 5,
            name: "filters",
            kind: "message",
            T: SyncFilter,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.connector.v1.SyncConnectorResponse
 */ export class SyncConnectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncConnectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncConnectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncConnectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncConnectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.connector.v1.SyncResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncConnectorResponse, "runtime", proto3);
_define_property(SyncConnectorResponse, "typeName", "mono.connector.v1.SyncConnectorResponse");
_define_property(SyncConnectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: SyncResult
        }
    ]));
/**
 * @generated from message mono.connector.v1.TestConnectionRequest
 */ export class TestConnectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new TestConnectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TestConnectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TestConnectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TestConnectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TestConnectionRequest, "runtime", proto3);
_define_property(TestConnectionRequest, "typeName", "mono.connector.v1.TestConnectionRequest");
_define_property(TestConnectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.connector.v1.TestConnectionResponse
 */ export class TestConnectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new TestConnectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TestConnectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TestConnectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TestConnectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TestConnectionResponse, "runtime", proto3);
_define_property(TestConnectionResponse, "typeName", "mono.connector.v1.TestConnectionResponse");
_define_property(TestConnectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Connector represents an external data source connector.
 *
 * @generated from message mono.connector.v1.Connector
 */ export class Connector extends Message {
    static fromBinary(bytes, options) {
        return new Connector().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Connector().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Connector().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Connector, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string type = 3;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: google.protobuf.Struct config = 6;
   */ _define_property(this, "config", void 0), /**
   * @generated from field: mono.connector.v1.ConnectorMetadata metadata = 7;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: mono.connector.v1.SyncStatistics statistics = 8;
   */ _define_property(this, "statistics", void 0), /**
   * @generated from field: google.protobuf.Duration sync_interval = 9;
   */ _define_property(this, "syncInterval", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_sync = 12;
   */ _define_property(this, "lastSync", void 0), /**
   * @generated from field: google.protobuf.Timestamp next_sync = 13;
   */ _define_property(this, "nextSync", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Connector, "runtime", proto3);
_define_property(Connector, "typeName", "mono.connector.v1.Connector");
_define_property(Connector, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "config",
            kind: "message",
            T: Struct
        },
        {
            no: 7,
            name: "metadata",
            kind: "message",
            T: ConnectorMetadata
        },
        {
            no: 8,
            name: "statistics",
            kind: "message",
            T: SyncStatistics
        },
        {
            no: 9,
            name: "sync_interval",
            kind: "message",
            T: Duration
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "last_sync",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "next_sync",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ConnectorMetadata holds additional connector information.
 *
 * @generated from message mono.connector.v1.ConnectorMetadata
 */ export class ConnectorMetadata extends Message {
    static fromBinary(bytes, options) {
        return new ConnectorMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConnectorMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConnectorMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConnectorMetadata, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string description = 1;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string version = 2;
   */ _define_property(this, "version", ""), /**
   * @generated from field: repeated string data_sources = 3;
   */ _define_property(this, "dataSources", []), /**
   * @generated from field: repeated string supported_formats = 4;
   */ _define_property(this, "supportedFormats", []), /**
   * @generated from field: repeated string capabilities = 5;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: repeated string tags = 6;
   */ _define_property(this, "tags", []), /**
   * @generated from field: map<string, string> custom_fields = 7;
   */ _define_property(this, "customFields", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConnectorMetadata, "runtime", proto3);
_define_property(ConnectorMetadata, "typeName", "mono.connector.v1.ConnectorMetadata");
_define_property(ConnectorMetadata, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "data_sources",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "supported_formats",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "custom_fields",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * SyncStatistics tracks connector sync history.
 *
 * @generated from message mono.connector.v1.SyncStatistics
 */ export class SyncStatistics extends Message {
    static fromBinary(bytes, options) {
        return new SyncStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncStatistics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 total_syncs = 1;
   */ _define_property(this, "totalSyncs", protoInt64.zero), /**
   * @generated from field: int64 successful_syncs = 2;
   */ _define_property(this, "successfulSyncs", protoInt64.zero), /**
   * @generated from field: int64 failed_syncs = 3;
   */ _define_property(this, "failedSyncs", protoInt64.zero), /**
   * @generated from field: google.protobuf.Duration last_sync_duration = 4;
   */ _define_property(this, "lastSyncDuration", void 0), /**
   * @generated from field: int64 documents_synced = 5;
   */ _define_property(this, "documentsSynced", protoInt64.zero), /**
   * @generated from field: int64 bytes_synced = 6;
   */ _define_property(this, "bytesSynced", protoInt64.zero), /**
   * @generated from field: double error_rate = 7;
   */ _define_property(this, "errorRate", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncStatistics, "runtime", proto3);
_define_property(SyncStatistics, "typeName", "mono.connector.v1.SyncStatistics");
_define_property(SyncStatistics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_syncs",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "successful_syncs",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "failed_syncs",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "last_sync_duration",
            kind: "message",
            T: Duration
        },
        {
            no: 5,
            name: "documents_synced",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "bytes_synced",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "error_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * SyncFilter constrains which data to sync.
 *
 * @generated from message mono.connector.v1.SyncFilter
 */ export class SyncFilter extends Message {
    static fromBinary(bytes, options) {
        return new SyncFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string operator = 2;
   */ _define_property(this, "operator", ""), /**
   * @generated from field: string value = 3;
   */ _define_property(this, "value", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncFilter, "runtime", proto3);
_define_property(SyncFilter, "typeName", "mono.connector.v1.SyncFilter");
_define_property(SyncFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "operator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SyncResult holds the outcome of a sync operation.
 *
 * @generated from message mono.connector.v1.SyncResult
 */ export class SyncResult extends Message {
    static fromBinary(bytes, options) {
        return new SyncResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string sync_id = 1;
   */ _define_property(this, "syncId", ""), /**
   * @generated from field: string connector_id = 2;
   */ _define_property(this, "connectorId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 documents_found = 4;
   */ _define_property(this, "documentsFound", 0), /**
   * @generated from field: int32 documents_synced = 5;
   */ _define_property(this, "documentsSynced", 0), /**
   * @generated from field: int32 documents_failed = 6;
   */ _define_property(this, "documentsFailed", 0), /**
   * @generated from field: int64 bytes_synced = 7;
   */ _define_property(this, "bytesSynced", protoInt64.zero), /**
   * @generated from field: int32 permissions_synced = 8;
   */ _define_property(this, "permissionsSynced", 0), /**
   * @generated from field: repeated string error_messages = 9;
   */ _define_property(this, "errorMessages", []), /**
   * @generated from field: google.protobuf.Duration duration = 10;
   */ _define_property(this, "duration", void 0), /**
   * @generated from field: google.protobuf.Timestamp start_time = 11;
   */ _define_property(this, "startTime", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_time = 12;
   */ _define_property(this, "endTime", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncResult, "runtime", proto3);
_define_property(SyncResult, "typeName", "mono.connector.v1.SyncResult");
_define_property(SyncResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sync_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "connector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "documents_found",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "documents_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "documents_failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "bytes_synced",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "permissions_synced",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "error_messages",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "duration",
            kind: "message",
            T: Duration
        },
        {
            no: 11,
            name: "start_time",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "end_time",
            kind: "message",
            T: Timestamp
        }
    ]));
